export class Organization {

  id: number;
  name: string;
  logo: string;
  seasonId: number;
  seasonName: string;
  colorGradient1: string;
  colorGradient2: string;
  orgTypeID: number;

  constructor(data) {
    this.id = +data.orgId;
    this.name = data.orgName;
    this.logo = data.orgLogo;
    this.seasonId = +data.orgSeasonId;
    this.seasonName = data.orgSeasonName;
    this.colorGradient1 = data.colorGradient1;
    this.colorGradient2 = data.colorGradient2;
    this.orgTypeID = +data.orgTypeID || null;
  }

}

export class OrganizationPast {

  id: number;
  name: string;
  logo: string;
  seasonId: number;
  seasonName: string;
  colorGradient1: string;
  colorGradient2: string;

  constructor(data) {
    //if (data) {
      this.id = +data.orgID;
      this.name = data.orgName;
      this.logo = data.orgLogo;
      this.seasonId = +data.orgSeasonID;
      this.seasonName = data.orgSeasonName;
      this.colorGradient1 = data.colorGradient1;
      this.colorGradient2 = data.colorGradient2;
    //}
  }

}



// WEBPACK FOOTER //
// ./src/app/models/association/organization.ts